import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ECBulkUpdateState {
  selectedIds: number[];
}

const initialState: ECBulkUpdateState = {
  selectedIds: [],
};

export const ecBulkUpdateSlice = createSlice({
  name: 'ecBulkUpdate',
  initialState,
  reducers: {
    setSelectedIds: (state, action: PayloadAction<number[]>) => {
      state.selectedIds = action.payload;
    },
    clearSelectedIds: (state) => {
      state.selectedIds = [];
    },
  },
});

export const { setSelectedIds, clearSelectedIds } = ecBulkUpdateSlice.actions;

export default ecBulkUpdateSlice.reducer;
